import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import rightArrow from "../../../../assets/img/arrow-right.svg";
import upload_icon from "../../../../assets/img/upload_icoon.svg";
import { showToast, ToastContainer } from "../../../../util/toastHelper";
import { ADMIN_CMS_FAQ } from "../../../../action/apiPath";
import { createShortNameFile, errorMessageCreate } from "../../../../util/custom";
import { ADMINCMSFAQSPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";
import { CallWithAuth } from "../../../../action/apiActions";

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminFaqUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [faq, setfaq] = useState({
        question: "",
        answer: ""
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        fetchFaq();
    }, [id]);

    const fetchFaq = async () => {
        setIsLoading(true);
        try {
            const response = await CallWithAuth("GET", `${ADMIN_CMS_FAQ}/${id}`);
            if (response?.res?.status === 200) {
                const data = response?.res?.data?.data;
                setfaq({
                    question: data.question,
                    answer: data.answer
                });
            } else {
                showToast("error", "Failed to fetch faq.");
            }
        } catch (err) {
            console.error(err);
            showToast("error", "An error occurred while fetching faq.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setfaq({ ...faq, [name]: value });
    };


    const handleSubmit = async () => {
        if (!faq.question) {
            showToast("error", "Question is required.");
            return;
        }

        if (!faq.answer) {
            showToast("error", "Answer is required.");
            return;
        }

        try {
            setIsSubmit(true);

            const response = await CallWithAuth("PATCH", `${ADMIN_CMS_FAQ}/${id}`, faq);
            const message = errorMessageCreate(response?.res?.data?.message);

            if (response?.res?.status === 200) {
                showToast("success", message);
                setTimeout(() => {
                    navigate(ADMINCMSFAQSPAGE);
                }, 1000);
            } else {
                showToast("error", message);
            }
        } catch (err) {
            console.error(err);
            showToast("error", "Failed to update faq.");
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <>
            <div>
                {isLoading && (<Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />)}

                <section className="site_hero patient_management_banner">
                    <div className="site_container">
                        <div className="site_row">
                            <div className="txt_colm">
                                <div className="txt_block">
                                    <h1>Update Faq</h1>
                                    <p>Edit and update existing faq information</p>
                                </div>
                            </div>
                            <div className="img_colm">
                                <div className="img_block">
                                    <img src={patient} alt="Patient" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mycustomclass patient_form_block">
                    <div className="site_container">
                        <div className="patient_form">
                            <div className="field_block">
                                <label htmlFor="question">Question*</label>
                                <input
                                    type="text"
                                    name="question"
                                    className="text_field"
                                    placeholder="Enter Question"
                                    value={faq.question}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field_block">
                                <label htmlFor="answer">Answer*</label>
                                <input
                                    type="text"
                                    name="answer"
                                    className="text_field"
                                    placeholder="Enter Answer"
                                    value={faq.answer}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field_block">
                                <div className="btn_row">
                                    <button disabled={isLoading || isSubmit} onClick={handleSubmit}>
                                        <span>Update</span> <img src={rightArrow} alt="Arrow" />
                                        {isSubmit && (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <ToastContainer />
            </div>
        </>
    );
};
export default AdminFaqUpdate;
